import type { AnyGameDefinition, GameDefinition } from "./types";

export class GameRegistry {
  readonly #definitions = new Map<string, AnyGameDefinition>();

  register<State>(definition: GameDefinition<State>): this {
    const key = GameRegistry.key(definition.gameId, definition.variantId);
    if (this.#definitions.has(key)) {
      throw new Error(`Duplicate game variant: ${key}`);
    }
    this.#definitions.set(key, definition as AnyGameDefinition);
    return this;
  }

  get<State = unknown>(gameId: string, variantId: string): GameDefinition<State> {
    const definition = this.#definitions.get(GameRegistry.key(gameId, variantId));
    if (!definition) throw new Error(`Unknown game variant: ${gameId}/${variantId}`);
    return definition as GameDefinition<State>;
  }

  games(): Array<{ id: string; name: string }> {
    const games = new Map<string, string>();
    for (const definition of this.#definitions.values()) {
      games.set(definition.gameId, definition.gameName);
    }
    return Array.from(games, ([id, name]) => ({ id, name }));
  }

  variants(gameId: string): AnyGameDefinition[] {
    return Array.from(this.#definitions.values()).filter(
      (definition) => definition.gameId === gameId,
    );
  }

  static key(gameId: string, variantId: string): string {
    return `${gameId}/${variantId}`;
  }
}
